/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// TODO: Fix eslint errors
import React from "react";
import { Buttons } from "@danishagro/cms/src/components/Buttons/Buttons.component";
import { cn } from "@danishagro/shared/src/helpers/classNames.helper";
import { DA_Container } from "@danishagro/shared/src/components/atoms/Container/Container.component";
import { DA_Text } from "@danishagro/shared/src/components/atoms/Text/Text.component";
import {
    DA_Title,
    DA_TitleTag,
} from "@danishagro/shared/src/components/atoms/Title/Title.component";
import { useBackgroundColor } from "@danishagro/cms/src/blocks/hooks/useBackgroundColor/useBackgroundColor.hook";
import { usePadding } from "src/blocks/hooks/usePadding/usePadding.hook";
import VideoPlayerViewer from "src/components/VideoPlayerViewer/VideoPlayerViewer.component";
import { TextVideoProps } from "./TextVideo.interface";
import { useAlignment } from "./hooks/useAlignment.hook";
import { usePosition } from "./hooks/usePosition.hook";
import { useSize } from "./hooks/useSize.hook";
import S from "./TextVideo.module.scss";

const TextVideo = (props: TextVideoProps) => {
    // Settings
    const { positionClass } = usePosition(props.position, S);
    const { backgroundColorClass, alternativeButtonTheme, hasBackgroundColor } = useBackgroundColor(
        props.backgroundColor
    );
    const { paddingClass } = usePadding(props.isCompact, hasBackgroundColor);
    const { alignmentClass } = useAlignment(props.alignment, S);
    const { sizeClass } = useSize(props.videoSize, S);

    return (
        <div
            className={cn(
                S.wrapper,
                paddingClass,
                positionClass,
                backgroundColorClass,
                alignmentClass,
                sizeClass
            )}
        >
            <DA_Container noVerticalPadding>
                <div className={S.inner}>
                    {/** Content */}
                    <div className={S.textWrapper}>
                        {/** Tagline */}
                        {props.tagline ? <span className={S.tagline}>{props.tagline}</span> : null}

                        {/** Title */}
                        {props.headline ? (
                            <div className={S.title}>
                                <DA_Title h2 tag={DA_TitleTag.H2} noMargin fullWidth>
                                    {props.headline}
                                </DA_Title>
                            </div>
                        ) : null}

                        {/** Text */}
                        {props.text ? (
                            <div className={S.text}>
                                <DA_Text html={props.text} noPadding />
                            </div>
                        ) : null}

                        {/** Buttons */}
                        {props.buttons && props.buttons.length > 0 && (
                            <div className={S.button}>
                                <Buttons buttons={props.buttons} theme={alternativeButtonTheme} />
                            </div>
                        )}
                    </div>

                    {/** Video */}
                    <div className={S.videoWrapper}>
                        <VideoPlayerViewer {...props} />
                    </div>
                </div>
            </DA_Container>
        </div>
    );
};

export default TextVideo;
